module.exports = __webpack_public_path__ + "img/dl3.9f9194c4.png";